import { appHttpRequest } from '@/utils/AppHttpRequest';
import { IPage } from '@/types/FmsTypes';
import { ISaleDetail, ISaleReturnDetail } from './bmsBillBusSoType';
class BusBusinesstService {
	//销售管理
	async saleOne(id: string) {
		const apiUrl = `/bcm/transit/sale/findById/${id}`;
		return await appHttpRequest.get<ISaleDetail>(apiUrl);
	}

	//销退管理
	async sreturnOne(id: string) {
		const apiUrl = `/bcm/transit/sreturn/findById/${id}`;
		return await appHttpRequest.get<ISaleReturnDetail>(apiUrl);
	}
}
export const busBusinesstService = new BusBusinesstService();
